<template>
  <payments-and-collections-settings />
</template>

<script>
import PaymentsAndCollectionsSettings from "@/components/3pl/Settings/PaymentsAndCollections/index";
export default {
  components: {
    PaymentsAndCollectionsSettings,
  },
};
</script>

<style></style>
